export default __webpack_public_path__ + "static/media/pic-8.60b47492.jpg";